module.exports = __webpack_public_path__ + "img/menu_btn.3be263d5.png";